import styled, { css } from 'styled-components'

export const OrdersSection = styled.section`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Badge = styled.p`
  all: unset;

  background: ${({ backColor }) => backColor || '#ff5733'};
  width: auto;
  padding: 5px;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  border-radius: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const Order = styled.article`
  width: 100%;
  height: auto;
  min-height: 80px;
  padding: 10px 20px;
  border-radius: 15px;

  background: ${({ backColor }) => backColor};

  display: flex;
  flex-direction: column;
  align-items: center;

  strong {
    font-size: 16px;
  }
`

export const Divider = styled.div`
  display: flex;
  justify-content: space-between;
`

export const SectionInfo = styled.section`
  width: 100%;

  display: grid;
  grid-template-columns: 100px 1fr 1fr 100px;
  align-items: center;
`

export const SectionPlusInfo = styled.section`
  width: 100%;
  padding: 20px;

  display: flex;
  justify-content: space-between;
`

export const Item = styled.article`
  width: 100%;
  padding: 15px;
`

export const User = styled.article`
  width: 100%;
  padding: 15px;
`

export const Total = styled.article`
  width: 100%;
  padding: 15px;
`

export const Text = styled.p`
  font-size: 12px;
  margin: 0;
  color: #575962;
  margin-bottom: ${({ mb }) => `${mb}px`};

  ${({ strong }) =>
    strong &&
    css`
      font-weight: bold;
    `}
`
